import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export default function Footer() {
    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                <div className={styles.section}>
                    <h3 className={styles.sectionTitle}>Nawigacja</h3>
                    <ul className={styles.linkList}>
                        <li><Link to="/" className={styles.link} onClick={() => window.scrollTo(0, 0)}>Strona Główna</Link></li>
                        <li><Link to="/o-mnie" className={styles.link} onClick={() => window.scrollTo(0, 0)}>O Mnie</Link></li>
                        <li><Link to="/oferta" className={styles.link} onClick={() => window.scrollTo(0, 0)}>Oferta</Link></li>
                        <li><Link to="/kontakt" className={styles.link} onClick={() => window.scrollTo(0, 0)}>Kontakt</Link></li>
                        <li><a href="/polityka-prywatności.pdf" className={styles.link} target="_blank" >Polityka Prywatności</a></li>
                        <li><a href="/Standardy-ochrony-maloletnich-Zaklinacze Mowy_2025.pdf" className={styles.link} target="_blank" >Standardy Ochrony Małoletnich</a></li>
                        <li><a href="/Zalaczniki-do-Standardow-Zaklinacze Mowy_2025.pdf" className={styles.link} target="_blank" >Załączniki do Standardów Ochrony Małoletnich</a></li>

                    </ul>
                </div>

                <div className={styles.section}>
                    <h3 className={styles.sectionTitle}>Kontakt</h3>
                    <div className={styles.contactInfo}>
                        <p>+48  503 466 099</p>
                        <p>zaklinaczemowy@gmail.com</p>
                        <p>ul. Bobrowskiego 5/2, Kraków</p>
                    </div>
                </div>

                <div className={styles.section}>
                    <h3 className={styles.sectionTitle}>Śledź nas</h3>
                    <div className={styles.socialLinks}>
                        <a 
                            href="https://www.facebook.com/people/Zaklinacze-Mowy/61582036533669/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="Facebook"
                        >
                            Facebook
                        </a>
                        <a 
                            href="https://www.instagram.com/zaklinaczemowy_neurologopeda/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="Instagram"
                        >
                            Instagram
                        </a>
                    </div>
                </div>
            </div>

            <div className={styles.bottomBar}>
                <p className={styles.copyright}>
                    © {new Date().getFullYear()} ZaklinaczeMowy. Wszelkie prawa zastrzeżone.
                </p>
            </div>
        </footer>
    );
}